"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var DebounceLink_1 = __importDefault(require("./DebounceLink"));
exports["default"] = DebounceLink_1["default"];
//# sourceMappingURL=index.js.map